import React from 'react';
import { TICKER_ITEMS, TECH_TAGS } from '../data/siteData';

function Ticker() {
  const doubled = [...TICKER_ITEMS, ...TICKER_ITEMS];
  return (
    <div className="ticker" aria-label="Technology stack ticker">
      <div className="ticker-wrap">
        {doubled.map((item, i) => (
          <div className="ti" key={i}>
            <span className="tic">●</span>{item}
          </div>
        ))}
      </div>
    </div>
  );
}

export default function Hero() {
  const handleScroll = (e, href) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
  };

  return (
    <>
      {/* Hero */}
      <section className="hero" id="home" aria-label="Hero section">
        <div className="hero-mesh" aria-hidden="true">
          <div className="mesh-circle mc1" />
          <div className="mesh-circle mc2" />
          <div className="mesh-circle mc3" />
          <div className="hero-dots" />
        </div>

        <div className="hero-inner">
          {/* Left: Copy */}
          <div>
            <div className="chip he-tag">
              <span>🤖</span> AI Agents · Cloud · Digital Transformation
            </div>
            <h1 className="he-h1">
              Building the<br />
              <em>Intelligent Future</em><br />
              of Enterprise
            </h1>
            <p className="he-p">
              JSDevBrains Digital Pvt Ltd — delivering cutting-edge AI Agents, Digital Automation,
              and Cloud Consulting to enterprises worldwide from Thanjavur, India.
            </p>
            <div className="he-btns">
              <a href="#services" className="btn btn-green" onClick={(e) => handleScroll(e, '#services')}>
                Explore Services →
              </a>
              <a
                href="https://wa.me/918123629993"
                target="_blank"
                rel="noopener noreferrer"
                className="btn btn-ghost"
              >
                💬 WhatsApp Us
              </a>
            </div>
            <div className="he-kpis" aria-label="Company statistics">
              {[
                { n: '50+', l: 'Projects' },
                { n: '5+', l: 'Countries' },
                { n: '3',  l: 'Products' },
                { n: '100%', l: 'Satisfaction' },
              ].map((k) => (
                <div className="kpi" key={k.l}>
                  <div className="kpi-n">{k.n}</div>
                  <div className="kpi-l">{k.l}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: Live AI card */}
          <div className="hero-visual">
            <div className="grab-card">
              <div className="gc-header">
                <div className="gc-avatar">AI</div>
                <div>
                  <div className="gc-title">AI Agent — Live Dashboard</div>
                  <div className="gc-sub">JSDevBrains Intelligent Operations</div>
                </div>
                <div className="gc-live">LIVE</div>
              </div>
              <div className="gc-body">
                <div className="agent-flow-vis">
                  {[
                    { icon: '🔍', label: 'Data Ingestion', sub: '4 live data sources streaming', badge: '✓ Done', bc: 'b-ok' },
                    { icon: '🧠', label: 'AI Processing', sub: 'LangChain + GPT-4o reasoning', badge: '⚡ Active', bc: 'b-run' },
                    { icon: '📤', label: 'Action Dispatch', sub: 'Webhooks + API triggers fired', badge: '↗ Queue: 3', bc: 'b-q' },
                  ].map((row) => (
                    <div className="afv-row" key={row.label}>
                      <div className="afv-ic" style={{ background: 'rgba(0,177,79,.1)' }}>{row.icon}</div>
                      <div className="afv-label">
                        {row.label}
                        <div className="afv-sub">{row.sub}</div>
                      </div>
                      <div className={`afv-badge ${row.bc}`}>{row.badge}</div>
                    </div>
                  ))}
                </div>
                <div className="gc-metrics">
                  {[
                    { n: '2,847', l: 'Tasks/hr', c: '#00B14F' },
                    { n: '99.2%', l: 'Accuracy', c: '#3B82F6' },
                    { n: '48ms', l: 'Latency', c: '#7C3AED' },
                  ].map((m) => (
                    <div className="gcm" key={m.l}>
                      <div className="gcm-n" style={{ color: m.c }}>{m.n}</div>
                      <div className="gcm-l">{m.l}</div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="gc-footer">
                <span>🔗 Connected to 4 enterprise systems</span>
                <span className="gc-uptime">↑ 99.98% uptime</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Ticker */}
      <Ticker />

      {/* Tech Marquee */}
      <div className="mq-sec" aria-label="Technologies we use">
        <div className="mq-label">Technologies & Frameworks We Use</div>
        <div className="mq-track">
          {[...TECH_TAGS, ...TECH_TAGS].map((tag, i) => (
            <span className="mqc" key={i}>{tag}</span>
          ))}
        </div>
      </div>
    </>
  );
}
